@if (formError) {
<div class="lin-form-error">{{ formError }}</div>
} @if (form) {
<form lin-layout-form [formGroup]="form" (ngSubmit)="saveData()">
  <lin-layout-form-sections-wrapper>
    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'FIELDS.EMAIL' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="email" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('email')" controlName="email"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'FIELDS.NAME' | translate }}:</lin-form-label>
      <mat-form-field color="accent">
        <input matInput formControlName="name" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('name')" controlName="name"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'FIELDS.SURNAME' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="surname" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('surname')" controlName="surname"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'FIELDS.PHONE_NUMBER' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput [dropSpecialCharacters]="false" mask="+0*" formControlName="phone" autocomplete="off" placeholder="+12345678" />
        <mat-error>
          <lin-form-field-error [control]="form.get('phone')" controlName="phone"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <label>{{ 'SETTINGS.TIMEZONE' | translate }}:</label>
      <mat-form-field>
        <lin-form-timezone-select [timezones]="timezones" formControlName="timezone"></lin-form-timezone-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('timezone')" controlName="timezone"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </lin-layout-form-section>

    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'FIELDS.ROLE' | translate }}:</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="role">
          @for (role of roles; track role.id) {
          <mat-option [value]="role.id">{{ role.displayName }}</mat-option>
          }
        </mat-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('role')" controlName="role"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <label>{{ 'FIELDS.POSITION' | translate }}:</label>
      <mat-form-field>
        <input matInput formControlName="position" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('position')" controlName="position"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </lin-layout-form-section>

    <lin-layout-form-section layout="triple">
      @if (canBeDualAccount) {
      <mat-checkbox class="dual-account" formControlName="isDualAccount">
        {{ 'ADMIN.CLIENTS.USERS.DUAL_ACCOUNT' | translate }}
      </mat-checkbox>
      } @if (hasDriverFields) {
      <label>{{ 'CLIENT.USERS.DRIVER_ID' | translate }}:</label>
      <mat-form-field>
        <input matInput formControlName="driverId" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('driverId')" controlName="driverId"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'FIELDS.DRIVER_SENSOR_ID' | translate }}:</lin-form-label>
      <lin-mac-address-form-field formControlName="driverSensorId" autocomplete="off"></lin-mac-address-form-field>
      @if (form.controls.driverSensorId?.errors?.server) {
      <mat-error class="driver-sensor-id-error"> {{form.controls.driverSensorId?.errors?.server}} </mat-error>
      }

      <lin-form-label>{{ 'ADMIN.CLIENTS.USERS.DEFAULT_TRIP_TYPE' | translate }}:</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="driverRouteScope">
          <mat-option value=""></mat-option>
          @for (scope of DriverRouteScopeLabel | keys; track scope) {
          <mat-option [value]="scope">{{ DriverRouteScopeLabel[scope] | translate }}</mat-option>
          }
        </mat-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('driverRouteScope')" controlName="driverRouteScope"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
      }
    </lin-layout-form-section>
  </lin-layout-form-sections-wrapper>
  <lin-layout-form-toolbar>
    <lin-form-submit-button [isLoading]="isSubmitting"> {{ 'BUTTONS.SAVE' | translate }} </lin-form-submit-button>
  </lin-layout-form-toolbar>
</form>
}
